import { lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AuthCallback from '@/pages/AuthCallback';
import { KioskShell } from '@/components/KioskShell';

const PublicProfile = lazy(() => import('@/pages/PublicProfile'));
const ItemDetail = lazy(() => import('@/pages/ItemDetail'));
const OrderDetailPage = lazy(() => import('@/pages/OrderDetailPage'));
const MenuPage = lazy(() => import('@/pages/MenuPage'));
const Terms = lazy(() => import('@/pages/Terms'));
const Privacy = lazy(() => import('@/pages/Privacy'));
const Safety = lazy(() => import('@/pages/Safety'));
const Disclaimer = lazy(() => import('@/pages/Disclaimer'));
const Contact = lazy(() => import('@/pages/Contact'));
const OwnerLogin = lazy(() => import('@/pages/OwnerLogin'));
const ResetPassword = lazy(() => import('@/pages/ResetPassword'));

/**
 * Retail-mode anonymous routes: single-seller storefront.
 * Marketplace pages, sign-up flows, market discovery, /shows, /game-stores,
 * /messages, etc. all collapse to the storefront. Owner signs in at /owner.
 */
export function RetailAnonRoutes() {
	return (
		<Routes>
			{/* Shareable single-store kiosk — locked, no nav, public to anyone.
			    Must be routed in retail mode too: QR codes at shows link here. */}
			<Route path="/s/:username/*" element={<KioskShell />} />
			{/* Retail storefront lives at root. /u/:username kept as a 301 so
			    old shared links keep working. */}
			<Route path="/" element={<PublicProfile />} />
			<Route path="/g/:gameSlug" element={<PublicProfile />} />
			<Route path="/menu/:id" element={<MenuPage />} />
			<Route path="/u/:username" element={<Navigate to="/" replace />} />
			<Route path="/u/:username/g/:gameSlug" element={<Navigate to="/" replace />} />
			<Route path="/u/:username/menu/:id" element={<MenuPage />} />
			<Route path="/u/:username/*" element={<Navigate to="/" replace />} />
			<Route path="/item/:id" element={<ItemDetail />} />
			{/* Cart hidden for MVP — /cart + /order/success redirect to storefront */}
			<Route path="/cart" element={<Navigate to="/" replace />} />
			<Route path="/order/success" element={<Navigate to="/" replace />} />

			<Route path="/order/:shortId" element={<OrderDetailPage />} />
			{/* Legal/info pages stay public so footer links work */}
			<Route path="/terms" element={<Terms />} />
			<Route path="/privacy" element={<Privacy />} />
			<Route path="/safety" element={<Safety />} />
			<Route path="/disclaimer" element={<Disclaimer />} />
			<Route path="/contact" element={<Contact />} />
			{/* Hidden operator sign-in. Not linked anywhere public. */}
			<Route path="/owner" element={<OwnerLogin />} />
			<Route path="/auth/callback" element={<AuthCallback />} />
			<Route path="/reset-password" element={<ResetPassword />} />
			{/* Everything else (market, inventory, shows, messages, /auth, etc.) → storefront */}
			<Route path="*" element={<Navigate to="/" replace />} />
		</Routes>
	);
}
